import { useQuery } from "@tanstack/react-query";
import { getProduct } from "../api/productService";

export default function useProduct(slug) {

    return useQuery({

        queryKey: ["product", slug],

        queryFn: () => getProduct(slug),

        enabled: !!slug,

        staleTime: 1000 * 60 * 5,

        retry: 1,

        refetchOnWindowFocus: false,

    });

}